import themeGet from '@styled-system/theme-get';
import styled from 'styled-components';

import Image from '../../../Core/Image';
import Container from '../../../Core/Container';
import checkMark from '../../../../images/checkmark-circle-icon.svg';

export const StyledContainer = styled(Container)`
  width: 100%;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: calc(100% - 80px);
  }
`;

export const Banner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: ${({ bgColor }) =>
    bgColor ? themeGet(`colors.${bgColor}`) : 'transparent'};

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    gap: 3rem;
    padding: 1.5rem 2rem;
    border-radius: 0.75rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    flex-direction: row;
  }
`;

export const Heading = styled.h2`
  font-size: 1.5rem;
  line-height: 150%;
  font-weight: ${themeGet('fontWeights.medium')};
  margin-bottom: 1.25rem;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    font-size: 2rem;
  }
`;

export const Content = styled.div`
  width: 100%;
  padding: 1.5rem 2rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding: unset;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 65%;
  }
`;

export const Body = styled.div`
  ul {
    margin-left: 0;
    li {
      background: url(${checkMark}) no-repeat left center;
      padding: 0 1rem 0 2.5rem;
      list-style: none;
      margin-top: 0;
      margin-bottom: 0.75rem;
      vertical-align: middle;

      @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
        margin-bottom: 1.25rem;
      }
    }
  }

  li:last-child {
    margin-bottom: 0;
  }

  p {
    font-size: 1rem;
    line-height: 150%;
  }
`;

export const Img = styled(Image)`
  margin: auto;
  max-height: 20rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 26rem;
  }
`;
